import type { Merchant } from '~entities/merchant';
import type { Pos } from '~entities/pos';

export const getUpToDateMerchantIds = (
  savedIds: string[],
  actualMerchants: Merchant[]
) => {
  const merchantSet = new Set(actualMerchants.map(({ id }) => id));
  return savedIds.filter((id) => merchantSet.has(id));
};

export const getUpToDatePosIds = (
  savedIds: string[],
  actualPointsOfSales: Pos[]
) => {
  const merchantSet = new Set(actualPointsOfSales.map(({ id }) => id));
  return savedIds.filter((id) => merchantSet.has(id));
};

export function getUpToDateStatuses<T>(
  savedStatuses: string[],
  actualStatuses: T[]
) {
  const statusesSet = new Set(actualStatuses as string[]);
  return savedStatuses.filter((status) => statusesSet.has(status)) as T[];
}
